import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./context/theme-context";
import { SideBarProvider } from "./context/side-bar-context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ThemeProvider>
    <SideBarProvider>
      <App />
    </SideBarProvider>
  </ThemeProvider>,
);
